import './Page1.css';
import { toJS } from 'mobx';
import { Paper } from 'material-ui';
import Alert from '../common/Alert';
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Observation from '../graph/Observation';


@inject('stationStore')
@observer
class Page1 extends Component {


  constructor(props, context) {
    super(props, context);
    this.state = {
      date: new Date(),
    };
  }

  render() {
    const { stationStore } = this.props;
    if (stationStore.stations) {
      return (
        <div>
          {stationStore.stations.map((station, i) => {
            let observationData = station.observations[0] && station.observations[0];
            if (!observationData.data) return null;

            let warningLevel = station.meta_data.find(item =>item.name && item.name === 'Warning Level'),
              dangerLevel = station.meta_data.find(item => item.name && item.name === 'Danger Level');

            return (
              <Paper zdepth={1} key={`${station.id}_${station.name}_graph_${i}`} style={{ padding: '5px 0', margin: '2px 0' }} className={`${station.alert && station.alert.danger ? 'graph-danger' : station.alert && station.alert.warning ? 'graph-warning' : ''}`}>
                <Observation series={observationData} station={{ name: station.name?station.name:'', type: station.type, warningLevel: warningLevel && warningLevel.value, dangerLevel: dangerLevel && dangerLevel.value }} />
              </Paper>
            )

            // return(
            //   d.observations[0] && d.observations[0].data ?
            //     <Paper zdepth={1} key={`${d.id}_${d.name}_graph_${i}`}>
            //       <Observation series={d.observations[0]} station={{ name: d.name, type: d.type }} />
            //     </Paper>
            //     : null
            // )
          })}
          <Alert type={stationStore.dangerStatus ? 'danger' : stationStore.warningStatus ? 'warning' : null} />
        </div>
       
      );
    }
  }
}

export default Page1;



// WEBPACK FOOTER //
// ./src/component/pages/Page1.js